<div class="p-grid p-ai-center p-jc-center h-100">
  <div class="login">
    <p-card  >
      <div class="login-logo p-mt-4">
        <img alt="logo" src="assets/img/logo.png">
      </div>
      <div class="login-title">
        <h2>¡Bienvenido a AXIAL!</h2>
        Por favor, introduce tu email y tu contraseña para acceder a la plataforma.
      </div>
      <div class="p-m-4">

        <div class="p-field">
          <label for="code">Cuenta</label>
          <input id="code" pInputText [(ngModel)]="loginData.code" placeholder="cuenta proporcionada" />
        </div>
        <div class="p-field">
          <label for="username">Email</label>
          <input id="username" pInputText [(ngModel)]="loginData.username" placeholder="nombre@email.com" (keyup.enter)="login()" />
        </div>
        <div class="p-field">
          <label for="password">Contraseña</label>
          <p-password id="password" [(ngModel)]="loginData.password" [toggleMask]="true" [feedback]="false" placeholder="Contraseña" (keyup.enter)="login()"></p-password>
        </div>

        <div class="p-mt-4">
          <p-checkbox id="remember" name="remember" [(ngModel)]="loginData.remember" binary="true" inputId="binary"></p-checkbox>
          <label for="remember"> Recordar datos en este equipo</label>
        </div>
        <div class="p-mt-4">
          <p-button label="Acceder" (click)="login()"></p-button>
        </div>
        <div class="p-mt-4">
          <a (click)="forget_password()">¿Ha olvidado su contraseña?</a>
        </div>
        <div class="p-mt-4" [hidden]="errorMessage==''">
          <p-message severity="error" text="{{errorMessage}}" class="p-d-block"></p-message>
        </div>

      </div>
    </p-card>
  </div>
  
</div>
